import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTrail, animated as a } from '@react-spring/web';

import * as AppPropTypes from '../../../lib/PropTypes';

import Detector from '../../partials/Detector';
import IntersectingVideo from './IntersectingVideo';
import Html from '../../partials/Html';

import styles from '../../../../styles/blocks/employee/title-pills.module.scss';

const propTypes = {
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    titlePills: AppPropTypes.titlePills,
};

const defaultProps = {
    className: null,
    isContainer: false,
    titlePills: null,
};

const TitlePills = ({ className, isContainer, titlePills }) => {
    const [visible, setVisible] = useState(false);

    const [springs, setSprings] = useTrail(titlePills?.length, () => ({
        transform: 'translateY(-10%)',
        opacity: 0,
    }));

    useEffect(() => {
        if (visible) {
            setSprings.start({
                transform: 'translateY(0)',
                opacity: 1,
            });
        } else {
            setSprings.start({
                transform: 'translateY(-10%)',
                opacity: 0,
            });
        }
    }, [visible]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Detector rootMargin="-30%" onChange={(v) => setVisible(v)}>
                <div
                    className={classNames([
                        styles.inner,
                        {
                            [styles.isContainer]: isContainer,
                        },
                    ])}
                >
                    {(springs || []).map((spring, i) => {
                        const {
                            color = null,
                            video = null,
                            title = null,
                            text = null,
                        } = titlePills[i] || {};
                        return (
                            <a.div
                                key={`pill-${title}`}
                                className={styles.titlePill}
                                style={{ ...spring, color: `${color}` }}
                            >
                                <IntersectingVideo
                                    src={video}
                                    type="video/mp4"
                                    muted
                                    loop
                                    className={styles.video}
                                    style={{ borderColor: `${color}` }}
                                />
                                <div className={styles.titleText}>
                                    <Html className={styles.title} tag="h3" body={title} />

                                    <p className={styles.text}>{text}</p>
                                </div>
                            </a.div>
                        );
                    })}
                </div>
            </Detector>
        </div>
    );
};

TitlePills.propTypes = propTypes;
TitlePills.defaultProps = defaultProps;

export default TitlePills;
